"use strict";
import { useMemo } from "react";
import { useTopazPoolFeeDetailsByAddress } from "components/lists/items/pools/useTopazPoolFeeDetailsByAddress";
import { OnchainItemListOptionType } from "components/lists/items/types";
import { UniverseChainId } from "features/chains/types";
import { useCurrencyInfos } from "features/tokens/useCurrencyInfo";
export function usePoolSearchResultsToPoolOptions(searchResults) {
  const currencyIds = useMemo(
    () => Array.from(new Set(searchResults.flatMap((result) => [result.token0CurrencyId, result.token1CurrencyId]))),
    [searchResults]
  );
  const currencyInfos = useCurrencyInfos(currencyIds);
  const hasMainnetPool = searchResults.some((result) => result.chainId === UniverseChainId.Mainnet);
  const { feeDetailsByAddress } = useTopazPoolFeeDetailsByAddress(UniverseChainId.Mainnet, hasMainnetPool);
  return useMemo(() => {
    const currencyIdToCurrencyInfo = Object.fromEntries(
      currencyInfos.map((currencyInfo) => [currencyInfo?.currencyId.toLowerCase(), currencyInfo])
    );
    return searchResults.map((searchResult) => {
      const { chainId, poolId, protocolVersion, hookAddress, feeTier, token0CurrencyId, token1CurrencyId } = searchResult;
      const token0CurrencyInfo = currencyIdToCurrencyInfo[token0CurrencyId.toLowerCase()];
      const token1CurrencyInfo = currencyIdToCurrencyInfo[token1CurrencyId.toLowerCase()];
      if (!poolId || !chainId || !protocolVersion || !feeTier || !token0CurrencyInfo || !token1CurrencyInfo) {
        return void 0;
      }
      return {
        type: OnchainItemListOptionType.Pool,
        poolId,
        chainId,
        protocolVersion,
        hookAddress,
        feeTier,
        feeDetails: chainId === UniverseChainId.Mainnet ? feeDetailsByAddress.get(poolId.toLowerCase()) : void 0,
        token0CurrencyInfo,
        token1CurrencyInfo
      };
    }).filter((option) => option !== void 0);
  }, [currencyInfos, searchResults, feeDetailsByAddress]);
}
